export default __webpack_public_path__ + "img/logoBlack.35d8a86b.png";